import { createContext, useContext, useState, useEffect, ReactNode } from 'react'

export interface TenantInfo {
  id: number
  name: string
  subdomain: string
}

interface AuthContextType {
  tenant: TenantInfo | null
  setTenant: (tenant: TenantInfo | null) => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [tenant, setTenant] = useState<TenantInfo | null>(() => {
    // Load from localStorage on init
    const stored = localStorage.getItem('tenant')
    return stored ? JSON.parse(stored) : null
  })

  // Persist to localStorage whenever it changes
  useEffect(() => {
    if (tenant) {
      localStorage.setItem('tenant', JSON.stringify(tenant))
      console.log('[Auth] Tenant stored:', tenant.subdomain)
    } else {
      localStorage.removeItem('tenant')
      console.log('[Auth] Tenant cleared')
    }
  }, [tenant])

  return (
    <AuthContext.Provider value={{ tenant, setTenant }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useTenant() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useTenant must be used within AuthProvider')
  }
  return context
}
